import { Text } from '../../Text';
import React, { Dispatch, PropsWithChildren, useRef, useState } from 'react';
import { commonStrings } from '../../../constants/strings';
import { NumberCount } from '../../NumberCount';
import { TextField } from '../../TextField';
import { Icon } from '../../Icon';

type Props = PropsWithChildren<{
  title: string;
  unreadCount?: number;
  onSearch: Dispatch<React.SetStateAction<string | undefined>>;
}>;

export function ChannelListHeader({
  title,
  unreadCount = 0,
  onSearch,
  children,
}: Props) {
  const timeoutRef = useRef<NodeJS.Timeout>();

  // State
  const [searchText, setSearchText] = useState<string>('');

  const onChangeSearch = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = e.target.value;
      setSearchText(value);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        onSearch(value.trim() || undefined);
      }, 500);
    },
    [onSearch]
  );

  return (
    <div className="p-4">
      <div className="flex items-center justify-between gap-2">
        <Text className="mr-auto" bold>
          {title}
        </Text>
        <NumberCount number={unreadCount} size="h-6" />
      </div>
      {children}
      <TextField
        name="search"
        onChange={onChangeSearch}
        value={searchText}
        inputClass="py-2 px-2"
        className="px-2 mt-4"
        placeholder={commonStrings.search}
        prefix={<Icon icon="searchInput" width={20} height={20} />}
      />
    </div>
  );
}
